<ion-grid [fixed]="true">
  <ion-row>
    <ion-col size="12" size-lg="6">
      <ion-grid [fixed]="true">
        <ion-row>
          @if(loading()) { @for (fake of fakeOffices(); track $index) {
          <ion-col size="12">
            <ion-card mode="ios" class="office-card fake">
              <ion-card-content>
                <ion-skeleton-text [animated]="true" style="width: 100%"></ion-skeleton-text>
                <ion-skeleton-text [animated]="true" style="width: 50%"></ion-skeleton-text>
              </ion-card-content>
            </ion-card>
          </ion-col>
          } } @else { @for (office of printOfficesWithOffer(); track office.id) {
          <ion-col size="12">
            <ion-card
              mode="ios"
              class="office-card"
              [class.selected]="office == selectedOffice()"
              (click)="onOfficeClick(office)">
              <ion-card-content class="d-flex">
                <ion-text> {{ office.name.en }}</ion-text>

                <div class="offered-price-wrap">
                  <ion-text> {{ getPrintPriceWithCommission(office) }} {{ "CURRENCY.TEXT" | translate }}</ion-text>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-col>
          } }

          @if(!loading() && printOfficesWithOffer().length == 0) {
          <ion-col size="12">
            <ion-text>
              <h3>{{ "OFFICE.NO_OFFERS_FOUND" | translate }}</h3>
            </ion-text>
          </ion-col>
          }
        </ion-row>
      </ion-grid>
    </ion-col>
    @if (!loading() && selectedOffice(); as selectedOffice) {
    <ion-col size="12" size-lg="6">
      <ion-grid [fixed]="true">
        <ion-row>
          <ion-col size="12">
            <ion-card class="selected-office-card" mode="md">
              <ion-card-header>
                <ion-text color="primary">
                  <h2>{{ selectedOffice.name.en }}</h2>
                </ion-text>
                <ion-text>
                  <h4>{{ "OFFICE.ADDRESS" | translate }}: {{ selectedOffice.address.en }}</h4>
                </ion-text>
                <ion-text class="price-text-wrap">
                  <h3>
                    {{ "OFFICE.OFFER.PRICE" | translate }}:
                    <ion-text color="success">
                      <span>{{ getPrintPriceWithCommission(selectedOffice) }} {{ "CURRENCY.TEXT" | translate }}</span>
                    </ion-text>
                  </h3>
                </ion-text>

                <ion-text class="details-price-wrap">
                  <ion-button (click)="openOfferModal()">
                    {{ "OFFICE.OFFER.DETAILS" | translate }}
                  </ion-button>
                </ion-text>
              </ion-card-header>
              <ion-card-content>
                <!-- @if(selectedOffice.imageSrc) {
                <ion-img [src]="selectedOffice.imageSrc" alt="office-img"> </ion-img>
                } -->
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-col>
    } @else if (loading()) {
    <ion-col size="12" size-lg="6">
      <ion-list>
        <ion-list-header>
          <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
        </ion-list-header>
        <ion-item>
          <ion-thumbnail slot="start">
            <ion-skeleton-text [animated]="true"></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
            <h3>
              <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text [animated]="true" style="width: 30%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-col>
    }
  </ion-row>
</ion-grid>
